export const WORKFLOW_ID = 'DecumulationWorkflow';
export const ANALYTICS_ID = 'decumulation_workflow';
export const BACKEND_DECUMULATION_GOAL_API = 'DecumulationGoal';

export enum DistributionStrategyTypeEnum {
  Percentage,
  Dollar,
}
